import React, {useEffect, useRef, useState} from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle, TextField, Tooltip, tooltipClasses, TooltipProps
} from '@mui/material';
import DialogTransition from '../DialogTransition/DialogTansition';
import {LoadingButton} from '@mui/lab';
import styled from "@emotion/styled";
import {hasThreeOfFour} from "../../utils/passwordcomplexity";

interface IChangePasswordDialogProps {
  userId: string;
  userName: string;
  email: string;
  open: boolean;
  onClose: () => void;
  onChange: (userId: string, newEmail: string) => void;
  loading: boolean;
}

export const ChangeUserEmailDialog: React.FC<IChangePasswordDialogProps > = ({
                                                                                  userId,
                                                                                  userName,
                                                                                  open,
                                                                                  onClose,
                                                                                  onChange, loading,
                                                                                }): React.JSX.Element => {
  const [newEmail, setNewEmail] = useState('');

  useEffect(() => {
    if (!open) {
      setNewEmail('');
    }
  }, [open])

  return (
    <Dialog TransitionComponent={DialogTransition} open={open}>
      <DialogTitle>Change Email for {userName}?</DialogTitle>
      <DialogContent>
      </DialogContent>
      <DialogActions>
        <Button disabled={loading} onClick={() => onClose()}>Cancel</Button>
        <LoadingButton loading={loading} color="error" onClick={() => onChange(userId, newEmail)}>Change</LoadingButton>
      </DialogActions>
    </Dialog>
  )
};
